import React, { useEffect, useMemo, useState } from "react";

import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";

import StyledScrollbar from "../../Common/UIComponents/StyledScrollbar";

import "./ExampleTable.css";

const TOTAL_ANALYSIS_COLS = 3;
const TOTAL_ROWS = 3;

export default function ExampleTable({
  selectedType = "product",
  fields,
  updatedLinkReport,
  updatedLinkPatternFields,
  onDownload,
}) {
  const [linkFields, setLinkFields] = useState([]);
  const [autoFillFields, setAutoFillFields] = useState([]);

  /**
   * Separate link report/pattern fields and autofill fields
   * @param {Array} allFields all fields
   * @param {Array} linkFieldNamesArray link report/pattern fields names array
   */
  const getFields = (allFields, linkFieldNamesArray) => {
    const safeLinks = linkFieldNamesArray || [];
    const link = allFields.filter((field) => safeLinks.includes(field.json_field));
    const autofill = allFields.filter((field) => !safeLinks.includes(field.json_field) && (field.field_autofill === "1" || field.test_autofill === "1"));
    return {
      link,
      autofill,
    };
  };

  useEffect(() => {
    const allFields = fields[selectedType];
    const { link, autofill } = getFields(allFields, selectedType === "product" ? updatedLinkReport : updatedLinkPatternFields);
    setLinkFields(link);
    setAutoFillFields(autofill);
  }, [fields, selectedType, updatedLinkReport, updatedLinkPatternFields, setLinkFields, setAutoFillFields]);

  const cols = useMemo(() => [
    ...linkFields,
    ...autoFillFields,
    ...Array(TOTAL_ANALYSIS_COLS),
  ], [linkFields, autoFillFields]);

  return (
    <div className="ExampleTableContainer">
      <div className="ExampleTable__Header">
        <span>Example</span>
        {onDownload && (
          <Button
            type="text"
            icon={<DownloadOutlined />}
            onClick={onDownload}
            className="ExampleTable__DownloadBtn"
            title="Download Template"
            aria-label="Download Template"
          />
        )}
      </div>
      <div
        className="ExampleTable__content"
      >
        <StyledScrollbar>
          <table className="ExampleTable__table">
            <thead>
              <tr>
                <th colSpan={linkFields.length}>{selectedType === "product" ? "Link Report Fields" : "Link Pattern Fields"}</th>
                {autoFillFields.length > 0 && <th colSpan={autoFillFields.length}>Autofill Fields</th>}
                <th colSpan={TOTAL_ANALYSIS_COLS}>Analysis</th>
              </tr>
            </thead>
            <tbody>
              {[...Array(TOTAL_ROWS)].map((_, index) => (
                <tr key={index}>
                  {cols.map((col, j) => {
                    if (index === 0) {
                      return col ? <td key={j}>{col.title_field}</td> : <td key={j}> </td>;
                    }
                    return <td key={j}> </td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </StyledScrollbar>
      </div>
    </div>
  );
}
